import React, { useState } from 'react';
import { AxisOptions, Chart } from 'react-charts';
import Card from '../../../components/card';
import { DatePicker } from 'antd';
import locale from 'antd/es/date-picker/locale/th_TH';
import dayjs from 'dayjs';
import { useQuery } from '@tanstack/react-query';
import { IOrderSumByDayReq, IOrderSumByDayRes } from '@/interfaces/order';
import { getOrderSumByDay } from '@/adapters/order';
import { AxiosResponse } from 'axios';

interface IChartData {
  label: string;
  data: IOrderSumByDayRes[];
}

const _criteria: IOrderSumByDayReq = {
  orderDay: dayjs().toDate(),
};

const OrderChart: React.FC = () => {
  const [criteria, setCriteria] = useState<IOrderSumByDayReq>({
    ..._criteria,
  });
  const { data: sums, isLoading } = useQuery<
    AxiosResponse<IOrderSumByDayRes[]>,
    Error
  >({
    queryKey: ['get-order-sub', criteria],
    queryFn: async () => await getOrderSumByDay(criteria),
  });

  const primaryAxis = React.useMemo(
    (): AxisOptions<IOrderSumByDayRes> => ({
      getValue: datum => datum.orderDay.toString(),
    }),
    [],
  );

  const secondaryAxes = React.useMemo(
    (): AxisOptions<IOrderSumByDayRes>[] => [
      {
        getValue: datum => datum.totalAmount,
      },
    ],
    [],
  );

  const orderSums = sums?.data || [];
  const data: IChartData[] = [
    {
      label: 'ยอดขาย',
      data: orderSums,
    },
  ];

  return (
    <Card customClass="flex flex-col drop-shadow-none p-4 gap-2">
      <div className="flex md:flex-row flex-col md:justify-between items-center gap-3">
        <h2 className="text-xl font-bold text-black">สรุปออเดอร์ประจำเดือน</h2>
        <DatePicker.MonthPicker
          size="large"
          locale={locale}
          defaultValue={dayjs()}
          onChange={date =>
            setCriteria({
              orderDay: date.toDate(),
            })
          }
        />
      </div>
      <div className="flex flex-row min-h-[300px] md:min-h-[400px] w-full">
        {!isLoading && data[0].data?.length && (
          <Chart
            options={{
              data,
              primaryAxis,
              secondaryAxes,
              defaultColors: ['#0a35c3'],
            }}
          />
        )}
      </div>
    </Card>
  );
};

export default OrderChart;
